<template>
  <div>
    <Headers></Headers>
    <router-view style="width: 1200px; min-height: 820px; margin: 0 auto"></router-view>
    <Footers></Footers>
  </div>
</template>
<script>
import Headers from "./components/headers";
import Footers from "./components/footers";
import DataApi from "@/core/zwzsw_api/manage.js";
export default {
  name: "homelist",
  components: {
    Headers,
    Footers,
  },
  created() {
  },
  mounted() {
    setTimeout(() => {
      document.title = sessionStorage.getItem("julistName");
    }, 600);
  },
  methods: {
  },
};
</script>

<style scoped></style>
